import Vue from 'vue';
import App from './App.vue';
// Vue Router
import router from './router';
// VueX (State Management)
import store from './store';

// ========== BUEFY (CSS Framework)
import Buefy from 'buefy';
//import 'buefy/dist/buefy.css';
import './assets/css/styles.scss';
Vue.use(Buefy);

// ========== Material Design Icons
import '@mdi/font/css/materialdesignicons.css';

// ========== VueJS JSON -> CSV utility
import JsonCSV from 'vue-json-csv';
Vue.component('exportCSV', JsonCSV);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
